<script lang="ts" setup>
import type { CompletedCheckDto } from '@/client';
import { useCompletedCheckStore } from '@/stores/completedcheck.store';
import { ref } from 'vue';
import moment from "moment-timezone";

const store = useCompletedCheckStore();
const loading = ref(true);
const params = defineProps({id: Number})
const completedcheck = ref(null as CompletedCheckDto | null);
enum InputTypes {
    Text,
    TextArea,
    CheckBox,
    FridgeTemp,
    FreezerTemp,
    HotHoldingTemp,
    CookingTemp,
    Signature,
    Select,
    Message,
    Timestamp,
    CoolingTemp,
    HotProbeTemp,
    ColdProbeTemp,
    ColdHoldingTemp,
    RegenerationTemp,
    CheckBoxNo,
    CustomTemperature,
    PhotoTask,
    CheckBoxWithNA,
    CheckBoxNoWithNA,
}
function isTemperatureInput(type: number | undefined) : boolean {
    if (type === undefined) return false;
    return (type === InputTypes.FridgeTemp || 
        type === InputTypes.FreezerTemp || 
        type === InputTypes.HotHoldingTemp || 
        type === InputTypes.CookingTemp || 
        type === InputTypes.CoolingTemp || 
        type === InputTypes.HotProbeTemp || 
        type === InputTypes.ColdProbeTemp || 
        type === InputTypes.ColdHoldingTemp || 
        type === InputTypes.RegenerationTemp ||
        type === InputTypes.CustomTemperature
    );
}

if (params.id !== 0) { 
    store.getCompletedCheck(Number(params.id)).then((x) => {
        completedcheck.value = x;
        loading.value = false;
    });
}

function getAnswer(id:string | undefined, suffix: string = "") {
    if (id == undefined) return "";
    if (completedcheck.value !== null)
        if (completedcheck.value.answers !== undefined) {
            if (completedcheck.value.answers.find(x => x.taskId === id)?.value === "Skipped") return "Skipped";
            return completedcheck.value.answers.find(x => x.taskId === id)?.value + suffix;
        }
}

function formatDate (d: Date | string | undefined | null, t:Boolean) {
    if (d === undefined || d === null) return "";
    if (t)
      return moment.utc(d).utcOffset((new Date()).getTimezoneOffset()*-1).format("DD/MM/YYYY HH:mm:ss");
    else
      return moment(d).format("DD/MM/YYYY");
};
</script>

<template>
<div v-if="!loading" style="color: #000">
    <div v-if="completedcheck != undefined && completedcheck?.check != undefined">
        <h3>{{ completedcheck?.check?.name }}</h3>
    </div>

    <div>
        <small>
            <strong>Completed:</strong> {{ formatDate(completedcheck?.createdOn, true) }} By {{ completedcheck?.by }}
        </small>
        <br />
    </div>

    <div class="pt-5">
        <div v-for="task in completedcheck?.answers" :key="task.taskId">
            <div class=" pt-2 content-center items-center gap-2">
                <div class="question basis-1/2">
                    {{ task.taskName }}: 
                    <span class="ccp" v-if="completedcheck?.check?.tasks?.find(x => x.id == task.taskId)?.isCCP">CCP</span>
                </div>
                <div class="answer">
                    <span v-if="task.type == 7">
                        <img style="max-width:350px;" :src="task.value?.split('|')[1]" />
                        <div><strong>{{ getAnswer(task.taskId)?.split("|")[0] }}</strong></div>
                    </span>
                    <span v-else-if="isTemperatureInput(task.type)">
                        {{  getAnswer(task.taskId, "&deg;C") }}
                    </span>
                    <span v-else-if="task.type == InputTypes.Timestamp || task.type == InputTypes.Message">
                        {{ formatDate(getAnswer(task.taskId), true) }}
                    </span>
                    <span v-else-if="task.type === InputTypes.PhotoTask">
                        <img :src="getAnswer(task.taskId, '')" alt="Photo Task" style="width: 200px;"  />
                    </span>
                    <span v-else> {{  getAnswer(task.taskId) }}</span>
                
                    <div :key="issue.id" v-for="issue in completedcheck?.issues?.filter(z => z.taskId === task.taskId)">
                        <div class="flex" style="gap:.8em">
                            <div>
                                <i v-if="issue.severity === 0" class="fa fa-triangle-exclamation text-orange-500"></i>
                                <i v-if="issue.severity === 1" class="fa fa-circle-exclamation text-orange-500"></i>
                            </div>
                            <div>{{ issue.description }}</div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
    <br />
    <br />
    <div v-if="completedcheck != undefined && completedcheck?.issues != undefined && completedcheck?.issues?.filter(z => z.taskId == null).length > 0">
        <h3 class="pt-3 pb-3 text-2xl font-bold">Reported Issues</h3>
        <div :key="issue.id" v-for="issue in completedcheck?.issues?.filter(z => z.taskId == null)">
            <div>
                <div class="flex gap-2">
                    <div>{{ formatDate(issue.createdOn, true) }}&nbsp;-&nbsp;</div>
                    <div>{{ issue.description }}</div>
                </div>
            </div>
        </div>
    </div>

</div>

</template>


<style>
.question{ font-weight: bold; margin-top: 10px;}
.ccp{ color: #ffa200; font-size: 12px; font-weight: bold;}
</style>